// extracted by mini-css-extract-plugin
export var mt0 = "fp-_C";
export var mt1 = "fp--C";
export var mt2 = "fp-0C";
export var mt3 = "fp-1C";
export var mt4 = "fp-2C";
export var mt5 = "fp-3C";
export var mt6 = "fp-4C";
export var widgetGetStarted = "fp-5C";
export var widgetGetStarted__copy = "fp-8C";
export var widgetGetStarted__ctas = "fp-9C";
export var widgetGetStarted__ctas__cta = "fp-aD";
export var widgetGetStarted__headline = "fp-7C";
export var widgetGetStarted__iconBg = "fp-6C";